import React from 'react'

export const PreviewEndSettings = () => {
  return (
    <>
      <div className="empty-message">
        <p>No options available</p>
      </div>
    </>
  )
}
